import ApiEndPoints from "../Enums/ApiEndPoint.enum";

import axios from "./Configuration/apiConfiguration";

/**
 * Request presigned URL for uploading images
 * @param data - Upload request data
 * @returns Promise with presigned URL and file URL
 */
const getPresignedUrl = (data: {
    uploadMethod: "presigned";
    fileName: string;
    contentType: string;
    expiresIn?: number;
}) =>
    new Promise((resolve, reject) => {
        axios
            .post(`${ApiEndPoints.upload}`, data)
            .then((apiResponse) => {
                resolve({ success: true, data: apiResponse?.data?.data });
            })
            .catch((apiFailed) => {
                reject(apiFailed);
            });
    });

export default {
    getPresignedUrl
};
